export default "__VITE_ASSET__64efadf5__"